var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85938 9.02344C7.96354 9.02344 7.09035 8.82372 6.23979 8.42427C5.38924 8.02483 4.63576 7.49705 3.97937 6.84094C3.32299 6.18483 2.79521 5.43135 2.39604 4.58052C1.99688 3.72969 1.79715 2.85649 1.79688 1.96094C1.79688 1.83594 1.83854 1.73177 1.92187 1.64844C2.00521 1.5651 2.10938 1.52344 2.23438 1.52344H3.92188C4.0191 1.52344 4.1059 1.55469 4.18229 1.61719C4.25868 1.67969 4.30382 1.75955 4.31771 1.85677L4.58854 3.3151C4.60243 3.41233 4.60063 3.50094 4.58313 3.58094C4.56562 3.66094 4.52576 3.73205 4.46354 3.79427L3.46354 4.8151C3.75521 5.3151 4.11979 5.78385 4.55729 6.22135C4.99479 6.65885 5.47743 7.03733 6.00521 7.35677L6.98438 6.3776C7.04688 6.3151 7.12854 6.2683 7.22937 6.23719C7.33021 6.20608 7.4291 6.19733 7.52604 6.21094L8.96354 6.5026C9.06076 6.52344 9.14062 6.57038 9.20312 6.64344C9.26562 6.71649 9.29688 6.80149 9.29688 6.89844V8.58594C9.29688 8.71094 9.25521 8.8151 9.17188 8.89844C9.08854 8.98177 8.98438 9.02344 8.85938 9.02344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.266928d8b5c9d246cfb0c4fd83df883c.svg";
export { ForwardRef as ReactComponent };